<template>
  <div class="login">
    <!-- 左：品牌面。夜色渐变 + 极淡的星点，呼应「夕梦」 -->
    <div class="stage">
      <div class="aurora"></div>
      <div class="stars"></div>
      <div class="stage-inner">
        <img src="@/assets/logo-mark.svg" alt="" class="stage-mark">
        <h1 class="stage-title">夕梦</h1>
        <p class="stage-sub">管理后台</p>
        <p class="stage-desc">匹配 · 音视频 · 内容审核 · 财务结算</p>
      </div>
      <p class="stage-foot">© {{ year }} 夕梦</p>
    </div>

    <!-- 右：表单面 -->
    <div class="panel">
      <div class="panel-inner">
        <img src="@/assets/logo-mark.svg" alt="" class="panel-mark">
        <h2 class="panel-title">欢迎回来</h2>
        <p class="panel-sub">请使用管理员账号登录</p>

        <a-form
          :model="formState"
          name="normal_login"
          layout="vertical"
          class="login-form"
          @finish="onFinish"
          @finishFailed="onFinishFailed"
        >
          <a-form-item
            label="用户名"
            name="userName"
            :rules="[{ required: true, message: '请输入用户名' }]"
          >
            <a-input v-model:value="formState.userName" size="large" placeholder="请输入用户名" autocomplete="username">
              <template #prefix><UserOutlined /></template>
            </a-input>
          </a-form-item>

          <a-form-item
            label="密码"
            name="password"
            :rules="[{ required: true, message: '请输入密码' }]"
          >
            <a-input-password v-model:value="formState.password" size="large" placeholder="请输入密码" autocomplete="current-password">
              <template #prefix><LockOutlined /></template>
            </a-input-password>
          </a-form-item>

          <a-form-item class="submit-item">
            <a-button
              :disabled="disabled"
              :loading="loading"
              type="primary"
              size="large"
              html-type="submit"
              class="submit-btn">
              登 录
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { defineComponent, ref, computed } from 'vue'
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { login } from '@/api/login'
import { message } from 'ant-design-vue'

export default defineComponent({
  name: 'Home',
  components: {
    UserOutlined,
    LockOutlined
  },
  setup () {
    const formState = ref({
      userName: '',
      password: '',
      remember: true
    })

    const router = useRouter()
    const store = useStore();
    const loading = ref(false)
    const year = new Date().getFullYear()

    const onFinish = (values) => {
      loading.value = true
      login(values).then(res => {
        if (res.success) {
          store.dispatch("setUserInfo", res.data);
          router.push({ name: 'home' })
        } else {
          message.error(res.message)
        }
      }).catch(error => {
        message.error(error.message || error)
      }).finally(() => {
        loading.value = false
      })
    }

    const onFinishFailed = (errorInfo) => {
      console.log('Failed:', errorInfo)
    }
    const disabled = computed(() => {
      return !(formState.value.userName && formState.value.password)
    })
    return {
      formState,
      loading,
      year,
      onFinish,
      onFinishFailed,
      disabled
    }
  }
})
</script>

<style scoped lang="less">
@import '@/style/variables.less';

.login {
  display: flex;
  min-height: 100vh;
  background: @bg-surface;
}

/* —— 左：品牌面 —————————————————————————— */
.stage {
  flex: 1 1 58%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(150deg, #241C56 0%, #3A2A8C 45%, #6C4DF6 100%);
}

/* 一层弥散的光晕，避免大块纯色显得死板 */
.aurora {
  position: absolute;
  inset: -30%;
  background:
    radial-gradient(46% 40% at 30% 30%, rgba(140, 114, 255, .42) 0%, transparent 72%),
    radial-gradient(40% 34% at 74% 68%, rgba(88, 190, 255, .22) 0%, transparent 72%),
    radial-gradient(34% 30% at 62% 12%, rgba(255, 255, 255, .10) 0%, transparent 70%);
  filter: blur(26px);
}

/* 星点用 radial-gradient 画，不额外引资源 */
.stars {
  position: absolute;
  inset: 0;
  opacity: .5;
  background-image:
    radial-gradient(1px 1px at 12% 18%, #fff, transparent),
    radial-gradient(1px 1px at 27% 41%, #fff, transparent),
    radial-gradient(1px 1px at 41% 12%, #fff, transparent),
    radial-gradient(1px 1px at 56% 33%, #fff, transparent),
    radial-gradient(1px 1px at 69% 8%,  #fff, transparent),
    radial-gradient(1px 1px at 83% 27%, #fff, transparent),
    radial-gradient(1px 1px at 8%  62%, #fff, transparent),
    radial-gradient(1px 1px at 22% 84%, #fff, transparent),
    radial-gradient(1px 1px at 37% 71%, #fff, transparent),
    radial-gradient(1px 1px at 52% 92%, #fff, transparent),
    radial-gradient(1px 1px at 66% 76%, #fff, transparent),
    radial-gradient(1px 1px at 78% 58%, #fff, transparent),
    radial-gradient(1px 1px at 91% 88%, #fff, transparent),
    radial-gradient(1px 1px at 95% 47%, #fff, transparent);
}

.stage-inner { position: relative; text-align: center; padding: 0 40px; }

.stage-mark {
  width: 68px;
  height: 68px;
  border-radius: 20px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, .28);
}
.stage-title {
  margin: 24px 0 0;
  font-size: 42px;
  font-weight: 700;
  letter-spacing: .22em;
  text-indent: .22em;      /* 字距居中补偿 */
  color: #fff;
}
.stage-sub {
  margin: 6px 0 0;
  font-size: 15px;
  letter-spacing: .34em;
  text-indent: .34em;
  color: rgba(255, 255, 255, .72);
}
.stage-desc {
  margin: 28px 0 0;
  font-size: 13px;
  color: rgba(255, 255, 255, .5);
  letter-spacing: .04em;
}
.stage-foot {
  position: absolute;
  bottom: 28px;
  margin: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, .38);
}

/* —— 右：表单面 —————————————————————————— */
.panel {
  flex: 0 0 clamp(380px, 42%, 480px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}
.panel-inner { width: 100%; max-width: 320px; }

.panel-mark { display: none; width: 44px; height: 44px; border-radius: 13px; margin-bottom: 18px; }

.panel-title { margin: 0; font-size: 26px; font-weight: 650; color: @text-1; }
.panel-sub { margin: 6px 0 30px; font-size: 13px; color: @text-3; }

.login-form :deep(.ant-form-item-label) { padding-bottom: 4px; }
.login-form :deep(.ant-form-item-label > label) { font-size: 13px; color: @text-2; }
.login-form :deep(.ant-input-prefix) { color: @text-4; margin-right: 8px; }
.login-form :deep(.ant-form-item) { margin-bottom: 18px; }

.submit-item { margin-top: 28px; margin-bottom: 0; }
.submit-btn {
  width: 100%;
  height: 42px;
  font-size: 15px;
  letter-spacing: .1em;
  border-radius: @radius-md;
  box-shadow: 0 6px 18px fade(@brand-500, 28%);
}
.submit-btn[disabled] { box-shadow: none; }

/* 窄屏收掉品牌面，只留表单 */
@media (max-width: 900px) {
  .stage { display: none; }
  .panel { flex: 1 1 100%; }
  .panel-mark { display: block; }
}
</style>
